import { SaveButton } from "components/Buttons"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  CustomRadioField,
  RadioField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap"
import { Field, change, formValueSelector, initialize } from "redux-form"
import {
  getMetaTags,
  getUsersBySearch,
  updateMediaGalleryDesign,
} from "store/actions"
import PropTypes from "prop-types"
import PhoneArea from "components/PhonePreview/PhoneArea"

const SelectLayout = props => {
  useEffect(() => {
    props?.getMetaTags({ hide_for_business_unit: 1 })
  }, [])

  useEffect(() => {
    if (props.mediaGalleryDesign) {
      props.initializeForm({
        media_gallery_form: {
          layout: props.mediaGalleryDesign.template_id.toString(),
          downloadsEnabled: props.mediaGalleryDesign.can_export === 1,
          uploadsEnabled: props.mediaGalleryDesign.can_upload === 1,
          downloadUsers: props?.mediaGalleryDesign?.media_download_access_type,
          uploadUsers: props?.mediaGalleryDesign?.media_upload_access_type,
          downloadUsersSearch:
            props?.mediaGalleryDesign?.mediaDownloadUsers?.map(user => ({
              ...user,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              value: user.id,
            })),
          downloadTagSearch: props?.mediaGalleryDesign?.downloadTags?.map(
            tag => ({
              ...tag,
              label: tag?.tag,
              value: tag?.id,
            })
          ),
          uploadUsersSearch: props?.mediaGalleryDesign?.mediaUploadUsers?.map(
            user => ({
              ...user,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              value: user.id,
            })
          ),
          uploadTagSearch: props?.mediaGalleryDesign?.uploadTags?.map(tag => ({
            ...tag,
            label: tag?.tag,
            value: tag?.id,
          })),
          notificationsEnabled:
            props?.mediaGalleryDesign?.notifications_disabled === 1,
        },
      })
    }
  }, [props.mediaGalleryDesign])

  const handleSubmit = () => {
    props.updateMediaGalleryDesign({
      ...props?.mediaGalleryDesign,
      template_id: parseInt(props?.formValues?.layout),
      can_export: props.formValues?.downloadsEnabled ? 1 : 0,
      can_upload: props.formValues?.uploadsEnabled ? 1 : 0,
      media_download_access_type: props?.formValues?.downloadUsers,
      media_upload_access_type: props?.formValues?.uploadUsers,
      mediaDownloadUsers:
        props.formValues?.downloadUsers === "users"
          ? props.formValues?.downloadUsersSearch
          : [],
      downloadTags:
        props.formValues?.downloadUsers === "tags"
          ? props.formValues?.downloadTagSearch
          : [],
      download_tag_ids:
        props.formValues?.downloadUsers === "tags"
          ? props.formValues?.downloadTagSearch?.map(tag => tag?.id)
          : [],
      mediaUploadUsers:
        props.formValues?.uploadUsers === "users"
          ? props.formValues?.uploadUsersSearch
          : [],
      uploadTags:
        props.formValues?.uploadUsers === "tags"
          ? props.formValues?.uploadTagSearch
          : [],
      upload_tag_ids:
        props.formValues?.uploadUsers === "tags"
          ? props.formValues?.uploadTagSearch?.map(tag => tag?.id)
          : [],
      notifications_disabled: props?.formValues?.notificationsEnabled ? 1 : 0,
    })
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row className="mb-3">
            <Col>
              <h3>{props.feature.label}</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h4>SELECT LAYOUT</h4>
                </CardHeader>
                <CardBody>
                  <Row className="my-2">
                    <Col xs="auto" className="mx-2">
                      <Field
                        name="layout"
                        value="1"
                        type="radio"
                        component={CustomRadioField}
                        img="https://admin.dev.markedprivate.com/app/images/templates/gallery_template1.png"
                      />
                    </Col>
                    <Col xs="auto" className="mx-3">
                      <Field
                        name="layout"
                        value="2"
                        type="radio"
                        component={CustomRadioField}
                        img="https://admin.dev.markedprivate.com/app/images/templates/gallery_template2.png"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h4>CONFIGS</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xs={12} className="my-1">
                      <Field
                        name="downloadsEnabled"
                        label="Download Media (photos & videos)"
                        component={CheckboxField}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            props?.change(
                              "media_gallery_form.downloadUsers",
                              "all"
                            )
                          } else {
                            props?.change(
                              "media_gallery_form.downloadUsers",
                              "none"
                            )
                          }
                        }}
                      />
                    </Col>
                    {props?.formValues?.downloadsEnabled && (
                      <>
                        <Row className="mb-3">
                          <Col xs={12} className="my-1">
                            <Field
                              name="downloadUsers"
                              value="all"
                              type="radio"
                              label="All Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="downloadUsers"
                              value="users"
                              type="radio"
                              label="Selected Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="downloadUsers"
                              value="tags"
                              type="radio"
                              label="Selected Tags"
                              component={RadioField}
                            />
                          </Col>
                          {props.formValues?.downloadUsers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="downloadUsersSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    include_admins: true,
                                    ...(props?.selectedEvent
                                      ? { event_id: props.selectedEvent.id }
                                      : {}),
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    include_admins: true,
                                    ...(props?.selectedEvent
                                      ? { event_id: props.selectedEvent.id }
                                      : {}),
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props.formValues?.downloadUsers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="downloadTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                      </>
                    )}
                    {!!props?.selectedEvent && (
                      <>
                        <Col xs={12} className="my-1">
                          <Field
                            name="uploadsEnabled"
                            label="Upload Media from Local Devices (photos & videos)"
                            component={CheckboxField}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                props?.change(
                                  "media_gallery_form.uploadUsers",
                                  "all"
                                )
                              } else {
                                props?.change(
                                  "media_gallery_form.uploadUsers",
                                  "none"
                                )
                              }
                            }}
                          />
                        </Col>
                        {props?.formValues?.uploadsEnabled && (
                          <>
                            <Row
                              className={
                                props?.formValues?.uploadUsers === "users"
                                  ? ""
                                  : "mb-3"
                              }
                            >
                              <Col xs={12} className="my-1">
                                <Field
                                  name="uploadUsers"
                                  value="all"
                                  type="radio"
                                  label="All Users"
                                  component={RadioField}
                                />
                              </Col>
                              <Col xs={12} className="my-1">
                                <Field
                                  name="uploadUsers"
                                  value="users"
                                  type="radio"
                                  label="Selected Users"
                                  component={RadioField}
                                />
                              </Col>
                              <Col xs={12} className="my-1">
                                <Field
                                  name="uploadUsers"
                                  value="tags"
                                  type="radio"
                                  label="Selected Tags"
                                  component={RadioField}
                                />
                              </Col>
                              {props.formValues?.uploadUsers === "users" && (
                                <Col xs={12} className="my-2">
                                  <Field
                                    name="uploadUsersSearch"
                                    component={AsyncTypeahedSelect}
                                    placeholder="Search for specific users"
                                    options={props.usersBySearch.map(user => ({
                                      ...user,
                                      label: `${user.first_name} ${user.last_name} (${user.email})`,
                                      value: user.id,
                                    }))}
                                    inlineValue={false}
                                    onInputChange={text =>
                                      props.getUsersBySearch({
                                        t: text,
                                        event_id: props.selectedEvent.id,
                                        include_admins: true,
                                      })
                                    }
                                    isMulti={true}
                                    onMenuClose={() => {
                                      props.getUsersBySearch({
                                        event_id: props.selectedEvent.id,
                                        include_admins: true,
                                      })
                                    }}
                                  />
                                </Col>
                              )}
                              {props.formValues?.uploadUsers === "tags" && (
                                <Col xs={12} className="my-2">
                                  <Field
                                    name="uploadTagSearch"
                                    placeholder="Enter tag"
                                    component={AsyncTypeahedSelect}
                                    options={props?.metaTags.map(tag => ({
                                      ...tag,
                                      label: tag.tag,
                                      value: tag.id,
                                    }))}
                                    isMulti={true}
                                  />
                                </Col>
                              )}
                            </Row>
                          </>
                        )}

                        <Col xs={12} className="my-1">
                          <Field
                            name="notificationsEnabled"
                            label="Disable Notifications"
                            component={CheckboxField}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </CardBody>
              </Card>
              <Row className="my-2">
                <Col className="d-flex justify-content-center">
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={handleSubmit}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={4} className="mt-4 custom-features-preview">
              <PhoneArea>
                <div
                  style={{
                    backgroundColor: "gray",
                    backgroundImage: `url(${
                      props?.formValues?.layout === "1"
                        ? "https://admin.dev.markedprivate.com/app/images/templates/gallery_template1.png"
                        : "https://admin.dev.markedprivate.com/app/images/templates/gallery_template2.png"
                    })`,
                    width: "108%",
                    height: "105%",
                    backgroundSize: "cover",
                    marginLeft: "-10px",
                    backgroundPosition: "center center",
                  }}
                />
              </PhoneArea>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.MEDIA_GALLERY)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  mediaGalleryDesign: state.MediaGallery.mediaGalleryDesign,
  formValues: selector(state, FORM_NAMES.MEDIA_GALLERY),
  usersBySearch: state.SiteUsers.usersBySearch,
  metaTags: state.Tags.metaTags,
})

const mapDispatchToProps = dispatch => ({
  updateMediaGalleryDesign: values =>
    dispatch(updateMediaGalleryDesign(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.MEDIA_GALLERY, values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.MEDIA_GALLERY, field, value)),
})

SelectLayout.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectLayout)
